<template>
  <basic-container>
    <avue-crud :option="option"
               v-if ="showCrud"
               :table-loading="loading"
               :data="data"
               :page="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot="projectIdSearch">
        <el-select v-model="queryProjectId" placeholder="请选择项目" @change="projectChanged">
          <el-option
            v-for="(item,index) in projectIdList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.definetest_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
      <template slot="menuLeft" slot-scope="scope" >
        <el-button type="info" size="small" icon="el-icon-plus" @click="addFormData(scope.row)">新增</el-button>
      </template>
    </avue-crud>
    <el-dialog title="新增"
               :visible.sync="dialogAddFormVisible"
               append-to-body>
      <avue-form :option="addFormOption" @submit="handleSubmit"></avue-form>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, getTableStructure,submitFormData} from "@/api/v4ward/test/definetest";
  import { getFormTemplateByProjectId } from '@/api/form';
  import {mapGetters} from "vuex";
  import {getProjectList} from "@/api/v4ward/ordersetting/setting/ordersetting";
  export default {
    data() {
      return {
        form: {},
        query: {},
        loading: true,
        queryProjectId: '',
        projectIdList: [],
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          selection: true,
          dialogClickModal: false,
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              type: "select",
              hide: true,
              editDisplay: false,
              addDisplay: false,
              viewDisplay: false,
              search: true,
              searchslot: true,
            },
            {
              label: "用户名",
              prop: "username",
              rules: [{
                required: true,
                message: "请输入用户名",
                trigger: "change"
              }]
            },
            {
              label: "备注",
              prop: "remark",
              rules: [{
                required: true,
                message: "请输入备注",
                trigger: "change"
              }]
            },
          ]
        },
        data: [],
        pageUrl: '/test/definetest',
        tempMainTableTemplateColumn:'',
        showCrud:false,
        dialogAddFormVisible: false,
        formTemplateData:{},
        addFormOption:{
          column:[],
        },
      };
    },
    created(){
      this.initProjectIdList();
      //this.getOption();
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.definetest_add, true),
          viewBtn: this.vaildData(this.permission.definetest_view, true),
          delBtn: this.vaildData(this.permission.definetest_delete, true),
          editBtn: this.vaildData(this.permission.definetest_edit, true)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      projectChanged() {
        console.log('---------------changed: ' + this.queryProjectId);
        this.getOption();
        this.loadFormOption();
      },
      initProjectIdList() {
        getProjectList().then(res => {
          this.projectIdList = res.data;
          console.log('===' + JSON.stringify(this.projectIdList));
          if (this.projectIdList.length > 0) {
            this.queryProjectId = this.projectIdList[0].id;
            this.getOption();
            this.loadFormOption();
            this.onLoad();
          }
        });
      },
      async loadFormOption() {
        getFormTemplateByProjectId(this.queryProjectId,'2',this.pageUrl).then((res)=>{
          this.formTemplateData = res.data.data;
          console.log(res.data.data);
        });
      },
      async getOption(){
        if(this.vdui.isEmpty(this.queryProjectId)){
          return;
        }
        if(this.queryProjectId)
        this.tempMainTableTemplateColumn = this.option.column;
        await getTableStructure({projectId: this.queryProjectId}).then((res)=>{
          console.log(res.data);
          this.$nextTick(()=>{
            this.option.column = res.data[this.pageUrl];
            this.showCrud = true;
          });
        });
      },

      //拼接表单属性
      addFormData(){
        let columnList = [];
        let self = this;
        if(self.formTemplateData.publicFormInfo.createJson){
          self.publicColumn = self.formTemplateData.publicFormInfo.createJson.fields
        }
        if(self.formTemplateData.mainFormInfo.createJson){
          self.mainColumn = self.formTemplateData.mainFormInfo.createJson.column
        }
        if(self.formTemplateData.extendFormInfo.createJson){
          self.extendColumn = self.formTemplateData.extendFormInfo.createJson.fields
        }
        console.log(self.publicColumn,self.extendColumn,self.mainColumn);
        columnList = columnList.concat(self.mainColumn);
        columnList = columnList.concat(self.publicColumn);
        columnList = columnList.concat(self.extendColumn);
        self.addFormOption.column = columnList;
        self.dialogAddFormVisible = true;
      },
      handleSubmit(form,done){
        console.log(form);
        //form.deptId = '1123598813738675201'
        form.pageUrl = this.pageUrl;
        form.mainFields = {};
        form.publicFields = {};
        form.extendFields = {};
        if(this.publicColumn.length>0){

          this.publicColumn.forEach((e)=>{
            form.publicFields[e.prop] = form[e.prop];
          });
        }
        if(this.mainColumn.length>0){

          this.mainColumn.forEach((e)=>{
            form.mainFields[e.prop] = form[e.prop];
          });
        }
        if(this.extendColumn.length>0){

          this.extendColumn.forEach((e)=>{
            form.extendFields[e.prop] = form[e.prop];
          });
        }
        console.log(form);
        //  return;
        let form_ = {
          fields:{

            extendFields:form.extendFields,

            publicFields:form.publicFields,
            mainFields:form.mainFields,
          },
          pageUrl:form.pageUrl,
          deptId:form.deptId
        };
        submitFormData(form_).then((res)=>{
          console.log(res);
          this.onLoad();
          this.$message.success('操作成功!');
          this.dialogAddFormVisible = false;
          done();
        });
        // done();
      },
      rowUpdate(row, index, done, loading) {
        this.editFormData();
        console.log(row);

        //  console.log(form);
        //row.deptId = '1123598813738675201'
        row.pageUrl = this.pageUrl;
        row.mainFields = {};
        row.publicFields = {};
        row.extendFields = {};
        if(this.publicColumn.length>0){

          this.publicColumn.forEach((e)=>{
            row.publicFields[e.prop] = row[e.prop];
          });
        }
        if(this.mainColumn.length>0){

          this.mainColumn.forEach((e)=>{
            row.mainFields[e.prop] = row[e.prop];
          });
        }
        if(this.extendColumn.length>0){

          this.extendColumn.forEach((e)=>{
            row.extendFields[e.prop] = row[e.prop];
          });
        }
        row.mainFields['id'] = row.id;
        let form_ = {
          fields:{

            extendFields:row.extendFields,

            publicFields:row.publicFields,
            mainFields:row.mainFields,
          },
          id:row.id,
          pageUrl:row.pageUrl,
          deptId:row.deptId
        };
        submitFormData(form_).then(
          () => {
            this.onLoad();
            this.$message.success('操作成功!');
            done();
          },
          (error) => {
            window.console.log(error);
            loading();
          }
        );
      },
      editFormData(){
        let columnList = [];
        let self = this;
        console.log(self.formTemplateData);
        if(self.formTemplateData.publicFormInfo.createJson){
          self.publicColumn = self.formTemplateData.publicFormInfo.createJson.fields
        }
        if(self.formTemplateData.mainFormInfo.createJson){
          self.mainColumn = self.tempMainTableTemplateColumn;
        }
        if(self.formTemplateData.extendFormInfo.createJson){
          self.extendColumn = self.formTemplateData.extendFormInfo.createJson.fields
        }
        console.log(self.publicColumn,self.extendColumn,self.mainColumn);
        columnList = columnList.concat(self.mainColumn);
        columnList = columnList.concat(self.publicColumn);
        columnList = columnList.concat(self.extendColumn);
        console.log(columnList);
        self.addFormOption.column = columnList;
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        this.query.projectId = this.queryProjectId;
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style>
</style>
